import { render, staticRenderFns } from "./stockEditDialog.vue?vue&type=template&id=5c508a72&"
import script from "./stockEditDialog.vue?vue&type=script&lang=js&"
export * from "./stockEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports